export default {
  UPDATE_ORDER: 'ORDER_HISTORY/UPDATE_ORDER',
  UPDATE_ORDERS: 'ORDER_HISTORY/UPDATE_ORDERS',
  DELETE_ORDER: 'ORDER_HISTORY/DELETE_ORDER',
  SELECT_TRANSFER_TABLE_GROUP: 'ORDER_HISTORY/SELECT_TRANSFER_TABLE_GROUP',
  SELECT_ORDER_TO_TRANSFER: 'ORDER_HISTORY/SELECT_ORDER_TO_TRANSFER',
};
